// @flow

import React from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import Map from '../../../components/googleMaps/Map';
import type { Building, Office } from '../../../types/OfficesType';
import GMMarker from '../../../components/googleMaps/GMMarker';
import yellowMarker from '../../../img/yellow-marker.png';

type Props = {
  building: Building,
  office: Office,
  apiKey: string,
}

type State = {
  selectedAreaAccess: number,
  mapIsReady: boolean
}

class LocationContacts extends React.Component<Props, State> {
  static defaultProps = {
    office: {},
  };

  state: State = {
    selectedAreaAccess: 0,
    mapIsReady: false,
  };

  render() {
    const generateIconClass = (area) => {
      switch (area.characteristicsType.id) {
        case 'metro':
          return 'fal fa-subway';
        case 'tram':
          return 'fal fa-tram';
        case 'bus':
          return 'fal fa-bus';
        case 'car':
          return 'fal fa-car';
        default:
          return '';
      }
    };

    return (
      <div className="locations-contacts">
        <div className="title">
          <Translate value="OFFICE.LOCATIONS_CONTACTS" />
        </div>

        <div className="location">
          <div className="column">
            <div className="data">
              {this.props.building.areaAccess &&
                <div className="buttons-container">
                  {this.props.building.areaAccess.map((area, index) => (
                    <button
                      key={area.characteristicsType.id}
                      className={`button ${this.state.selectedAreaAccess === index ? 'selected' : ''}`}
                      onClick={() => {
                        this.setState({ selectedAreaAccess: index });
                      }}
                    >
                      <div className="logo-container">
                        <i className={generateIconClass(area)} />
                      </div>
                      {area.characteristicsType.label}
                    </button>
                  ))
                  }
                </div>
                }
            </div>
            <div className="data">
              {
                  (this.props.building.areaAccess
                    && this.props.building.areaAccess[this.state.selectedAreaAccess])
                  && (
                    <div
                      className="content"
                      dangerouslySetInnerHTML={
                        {
                          __html: this.props.building
                            .areaAccess[this.state.selectedAreaAccess].value,
                        }
                      }
                    />
                  )
                }
            </div>
          </div>
          <div className="block">
            <div className="place">
              <p className="name">{this.props.building.title}</p>
              <p className="address">{this.props.office.address}</p>
              <p className="city">{this.props.office.city}, {I18n.t(`country.${this.props.office.countryCode}`)}</p>
            </div>
            <div className="map">
              {
                  this.props.office.latitude
                  && this.props.office.longitude
                  && this.props.apiKey
                    ? (
                      <Map
                        className="catchment-area-map"
                        latitude={Number(this.props.office.latitude)}
                        longitude={Number(this.props.office.longitude)}
                        zoom={14}
                        apiKey={this.props.apiKey}
                        googleIsReady={() => this.setState({ mapIsReady: true })}
                      >
                        {
                          this.state.mapIsReady
                          && (
                            <GMMarker
                              name={this.props.building.title}
                              title={this.props.building.title}
                              position={{
                                lat: Number(this.props.office.latitude),
                                lng: Number(this.props.office.longitude),
                              }}
                              icon={{
                                url: yellowMarker,
                                scaledSize: new google.maps.Size(32, 40),
                              }}
                            />
                          )
                        }
                      </Map>
                    ) : (
                      <div className="no-map">
                        <i className="fa fa-map-marker-alt-slash" />
                        No coordinates given
                      </div>
                    )
                }
            </div>
          </div>
          <div className="column">
            <div className="data">
              {
                  this.props.building.companies
                  && this.props.building.companies.length > 0
                  && (
                    <div className="data-title">
                      <Translate value="OFFICE.COMPANIES" />
                    </div>
                  )
                }
            </div>
            <div className="data">
              {this.props.building.companies
                && (
                  <div className="content">
                    {
                      this.props.building.companies.map(compagnie => (
                        <div key={compagnie.id}>
                          {compagnie.name}
                        </div>
                      ))
                    }
                  </div>
                )
                }
            </div>
          </div>
        </div>

        {/* <div className="location"> */}
        {/* </div> */}

        {/* <div className="location"> */}


        {/* </div> */}
        <div className="contacts">
          <div className="contact-title">
            <Translate value="OFFICE.CONTACT" />
          </div>
          <div className="contact">
            <div className="name">{this.props.building.directorName}</div>
            <div className="phone">{this.props.building.directorPhone}</div>
            <div className="mail">{this.props.building.directorEmail}</div>
          </div>
          <div className="links">
            <div className="link">
              <i className="fa fa-desktop" />
              <a
                className="web"
                href={`${this.props.building.websiteUrl}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Translate value="OFFICE.WEBSITE" />
              </a>
            </div>
            <div className="link">
              <i className="fa fa-envelope-open" />
              <a className="mail" href={`mailTo:${this.props.building.directorEmail}`}>
                <Translate value="OFFICE.EMAIL" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  apiKey: state.google.mapsApiKey,
}), {})(LocationContacts);
